import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Divider, Flex, Paper, Stack, Text } from "@mantine/core";
import { IconChevronRight, IconEyeOff } from "@tabler/icons-react";

import { CampaignItem } from "./CampaignItem";

export const CampaignsInTesting = () => {
    const { t } = useTranslation(["common"]);
    const navigate = useNavigate();
    const campaignsInTesting = [
        {
            id: "1",
            name: "Skleněná lahev Philips Avent Natural Response proti kolice",
            image: "https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/images/bg-7.png",
            dateFrom: "24. 7. 2022",
            dateTo: "27. 7. 2022",
            reviews: 81,
            rating: 4.4,
            score: 80.4,
        },
        {
            id: "2",
            name: "Skleněná lahev Philips Avent Natural Response proti kolice",
            dateFrom: "24. 7. 2022",
            dateTo: "27. 7. 2022",
            reviews: 81,
            rating: 4.4,
            score: 50.4,
        },
    ];
    return (
        <Paper p={28} radius={12}>
            <Text mb={24} weight={600}>
                {t("dashboard_in_progress_testing")}
            </Text>
            <Stack spacing={16}>
                {campaignsInTesting.map((campaign, index) => (
                    <>
                        {index > 0 && <Divider color="#EEEFF2" />}
                        <CampaignItem {...campaign} />
                    </>
                ))}
                {campaignsInTesting.length === 0 && (
                    <Flex
                        onClick={() => {
                            navigate("/campaigns");
                        }}
                        px={12}
                        py={8}
                        gap={8}
                        align="center"
                        style={{
                            backgroundColor: "#e2f8ff",
                            borderRadius: 12,
                            cursor: "pointer",
                        }}
                    >
                        <IconEyeOff size={26} color="#30A9D4" />
                        <Text
                            size={18}
                            weight={700}
                            color="#30A9D4"
                            style={{
                                lineHeight: 1.2,
                            }}
                        >
                            {t("dashboard_in_progress_join_testing")}
                        </Text>
                        <IconChevronRight stroke={3} style={{ marginLeft: "auto" }} color="#30A9D4" size={18} />
                    </Flex>
                )}
            </Stack>
        </Paper>
    );
};
